import { Button, Form, Table, Pagination, Input, message, Select, Space } from "antd";
import FullHeightLayout from "../../components/FullHeightLayout";
import { useEffect, useRef, useState } from "react";
import renderFileList from "../../components/renderFileList";
import { checkp, getobjkeys, exportToCSV } from "../../utils/functions";
import DateInput from "../../components/DateInput";
import ImgUploader from "../../components/ImgUploader";
import CustModal from "../../components/ShowModal";
import useWebPost from "../../utils/useWebPost";
import ProjectImport from "../../components/Tbimport";

const { Option } = Select;

function HrResource() {
    const webPost = useWebPost();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [currentItem, setCurrentItem] = useState(null);
    const [data, setData] = useState([]);
    const [modalType, setModalType] = useState(null);
    const [form] = Form.useForm();
    const loadingRef = useRef();
    const pageSizeOptions = [20, 50, 100, 500];

    const columns = [
        {
            title: '序号',
            dataIndex: 'xd',
            width: 64,
            render: (_, __, index) => index + 1 + (page - 1) * pageSize
        },
        { title: '姓名', dataIndex: 'name', width: 120 },
        { title: '性别', dataIndex: 'gender', width: 80 },
        { title: '年龄', dataIndex: 'age', width: 80 },
        { title: '职务、工种', dataIndex: 'job', width: 150 },
        { title: '学历', dataIndex: 'education', width: 120 },
        { title: '身份证号码', dataIndex: 'id_card', width: 180 },
        { title: '联系电话', dataIndex: 'phone', width: 130 },
        { title: '住址', dataIndex: 'address', width: 200 },
        { title: '入职日期', dataIndex: 'entry_date', width: 120 },
        { title: '职业证书名称', dataIndex: 'certificate_name', width: 180 },
        {
            title: '附件',
            dataIndex: 'files',
            width: 200,
            render: (_) => renderFileList(_)
        },
        { title: '状态', dataIndex: 'status', width: 100 },
        { title: '是否隐藏', dataIndex: 'is_hidden', width: 100 },
        { title: '备注', dataIndex: 'remark', width: 140 },
        checkp("rlzym") && {
            title: '操作',
            dataIndex: 'op',
            width: 100,
            render: (_, rs) => <Button type="link" onClick={() => modRecord(rs)}>修改</Button>
        },
    ].filter(Boolean);

    const modRecord = (rs) => {
        setCurrentItem(rs);
        // 如果是编辑模式，设置表单值；否则重置表单
        rs?.id ? form.setFieldsValue(rs) : form.resetFields();
    };

    const onPageChange = (page, size) => {
        let finalPage = page;
        let finalSize = size;
        if (finalSize !== pageSize) {
            finalPage = 1;
            setPageSize(finalSize);
        }
        setPage(finalPage);
        getItems(finalPage, finalSize);
    };

    useEffect(() => {
        getItems(page, pageSize);
    }, [page, pageSize]);

    const getItems = async (page, limit) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        try {
            const params = { page, limit };
            const response = await webPost('hrList', params);
            if (response && response.data) {
                if (response.total < 1) {
                    message.info('未找到匹配数据');
                }
                setData(response.data);
                setTotal(response.total);
            }
        } catch (e) {
            console.error("获取数据失败:", e);
            setData([]);
            setTotal(0);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    };

    const handleOk = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        let suc = false;
        try {
            const values = await form.validateFields();
            const params = { ...values, id: currentItem?.id };
            const response = await webPost('saveHr', params); // 假设保存接口名为 saveHr

            if (response) {
                message.success("保存成功");
                setCurrentItem(null);
                suc = true;
            }
        } catch (error) {
            if (error.name === 'ValidationError') {
                message.error("请检查表单填写是否正确");
            } else {
                message.error("保存失败");
            }
        } finally {
            loadingRef.current = false;
            setLoading(false);
            if (suc) getItems(page, pageSize);
        }
    };

    return (
        <FullHeightLayout
            headerContent={
                <div style={{ 'display': 'flex', 'width': '100%' }}>
                    {checkp("rlzym") && (
                        <Button type="primary" onClick={() => modRecord({ id: 0 })}>
                            新增人员
                        </Button>
                    )}
                    <div style={{ 'flex': 1 }}></div>
                    {checkp("rlzym") && (
                        <Button type="default" onClick={() => setModalType("import")}>
                            批量上传
                        </Button>
                    )}
                    <Button style={{margin:'0 10px'}} type="dashed" onClick={() => exportToCSV(data, columns.slice(0, -1), '人力资源台账')}>
                        下载本页数据
                    </Button>
                </div>
            }
            footerContent={
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Pagination
                        current={page}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        >
            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                bordered
                pagination={false}
                scroll={{ x: 'max-content', y: 'calc(100vh - 260px)' }}
                tableLayout="fixed"
                loading={loading}
            />

            <CustModal
                title={currentItem?.id ? '编辑人员信息' : '新增人员'}
                open={currentItem !== null}
                onOk={handleOk}
                onCancel={() => setCurrentItem(null)}
                okText="保存"
                width={800}
            >
                <Form form={form} layout="horizontal" labelCol={{ span: 6 }}>
                    <Form.Item name="name" label="姓名" rules={[{ required: true, message: '请输入姓名' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="gender" label="性别" rules={[{ required: true, message: '请选择性别' }]}>
                        <Select>
                            <Option value="男">男</Option>
                            <Option value="女">女</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="age" label="年龄">
                        <Input type="number" />
                    </Form.Item>
                    <Form.Item name="job" label="职务、工种">
                        <Input />
                    </Form.Item>
                    <Form.Item name="education" label="学历">
                        <Input />
                    </Form.Item>
                    <Form.Item name="id_card" label="身份证号码">
                        <Input />
                    </Form.Item>
                    <Form.Item name="phone" label="联系电话">
                        <Input />
                    </Form.Item>
                    <Form.Item name="address" label="住址">
                        <Input />
                    </Form.Item>
                    <Form.Item name="entry_date" label="入职日期">
                        <DateInput />
                    </Form.Item>
                    <Form.Item name="certificate_name" label="职业证书名称">
                        <Input />
                    </Form.Item>
                    <Form.Item name="files" label="附件">
                        <ImgUploader />
                    </Form.Item>
                    <Form.Item name="status" label="状态">
                        <Input />
                    </Form.Item>
                    <Form.Item name="is_hidden" label="是否隐藏">
                        <Select>
                            <Option value="否">否</Option>
                            <Option value="是">是</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="remark" label="备注">
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </CustModal>
            <ProjectImport
                visible={modalType === 'import'}
                onClose={() => { setModalType(null) }}
                onSave={() => { setModalType(null); getItems(1, pageSize) }}
                Dbname="hr_resource"
            />
        </FullHeightLayout>
    );
}

export default HrResource;